import { useDevMode } from '@plug-core/state'
import { Text } from '@ui'
import React, { FC, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const ExtensionContainer: FC<Props> = ({ children }) => {
  const { devEnabled } = useDevMode()

  return (
    <div className="relative flex h-dvh w-screen flex-col overflow-hidden text-fg sm:flex-row">
      {devEnabled && (
        <div className="absolute inset-x-0 top-0 z-[1000] flex h-[30px] items-center justify-center border-b border-solid border-hairline bg-surface backdrop-blur">
          <Text variant="label">🧪 DEV MODE</Text>
        </div>
      )}
      {children}
    </div>
  )
}

export default ExtensionContainer
